exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.kv-html-content * {\n  margin: 0 !important;\n}\n.empty-state-icon {\n  background-color: #f5f5f5;\n  border-radius: 50%;\n  width: 100px;\n  height: 100px;\n}\n.notes-scroll-container {\n  flex: 1;\n  min-height: 0;\n  overflow: hidden;\n}\n", ""]);

// exports
